import type { HostRole, MeetingContext, MeetingKind } from '@/app/queries/MeetingContextQuery/fetchMeetingContext';

export interface MeetingCopy {
  title: string;
  feedbackQuestion: string;
  asksForPublicReview: boolean;
  hostTitle: string;
}

type KindCopy = Omit<MeetingCopy, 'hostTitle'>;

const LVE_COPY: KindCopy = {
  title: 'Live Video Estimate',
  feedbackQuestion: 'How was your live video estimate?',
  asksForPublicReview: true,
};

// Pre-visits and revisits get stars only, with no public-review ask
// (CAD-9644 PRD, decision D3).
const COPY_BY_KIND: Partial<Record<MeetingKind, KindCopy>> = {
  previsit: {
    title: 'Pre-visit video call',
    feedbackQuestion: 'How was your pre-visit video call?',
    asksForPublicReview: false,
  },
  revisit: {
    title: 'Revisit video call',
    feedbackQuestion: 'How was your revisit video call?',
    asksForPublicReview: false,
  },
};

const DEFAULT_HOST_TITLE = 'Sales rep';

const HOST_TITLE_BY_ROLE: Partial<Record<HostRole, string>> = {
  installer: 'Installer',
};

export const copyFor = (context: MeetingContext | null): MeetingCopy => ({
  ...(context && COPY_BY_KIND[context.kind]) ?? LVE_COPY,
  hostTitle: (context && HOST_TITLE_BY_ROLE[context.hostRole]) ?? DEFAULT_HOST_TITLE,
});
